import { render, staticRenderFns } from "./SaveQueryModal.vue?vue&type=template&id=793592cb&"
import script from "./SaveQueryModal.vue?vue&type=script&lang=js&"
export * from "./SaveQueryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports